// extracted by mini-css-extract-plugin
module.exports = {"loginContainer":"style_loginContainer__fbZCM","forgotPasswordLink":"style_forgotPasswordLink__1Yu44"};